













import { Component, Vue, Watch } from "vue-property-decorator";
import { Button, Dialog } from "vant";
import { getBrowser } from "@/utils/browser";
import MessageArea from "./MessageArea.vue";
const browser = getBrowser();

@Component({
  components: {
    MessageArea,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component
  }
})
export default class Login extends Vue {
  isApp = browser.isApp;
  isOriginHei = true;
  screenHeight = document.body.clientHeight; //此处也可能是其他获取方法
  originHeight = document.body.clientHeight;
  showForgetPasswordDialog = false;

  @Watch("screenHeight")
  watchScreenHeight(val) {
    
    if (this.originHeight > val + 100) {
      //加100为了兼容华为的返回键
      this.isOriginHei = false;
    } else {
      this.isOriginHei = true;
    }
  }

  mounted() {
    

    window.onresize = () => {
      return (() => {
        this.screenHeight = document.body.clientHeight;
      })();
    };
  }

  handleLoginTypeClick(path) {
    const currentPath = this.$route.fullPath;
    if (currentPath !== path) {
      this.$router.replace(path);
    }
  }
}
